import { render, staticRenderFns } from "./HealthWidget.vue?vue&type=template&id=a0e37d3e&scoped=true&"
import script from "./HealthWidget.vue?vue&type=script&lang=js&"
export * from "./HealthWidget.vue?vue&type=script&lang=js&"
import style0 from "./HealthWidget.vue?vue&type=style&index=0&id=a0e37d3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e37d3e",
  null
  
)

export default component.exports